import { createContext, useContext } from "react";
import { useParams, Navigate, Outlet } from "react-router-dom";
import { isLocale, DEFAULT_LOCALE, type Locale } from "./locales";

const LocaleContext = createContext<Locale>(DEFAULT_LOCALE);

/** Route wrapper: validates locale param, renders Outlet inside LocaleProvider */
export function LocaleGate() {
  const { locale } = useParams<{ locale?: string }>();
  // Invalid locale segment → fall through to 404
  if (locale && !isLocale(locale)) return <Navigate to="/" replace />;
  const resolved: Locale = locale && isLocale(locale) ? locale : DEFAULT_LOCALE;
  return (
    <LocaleContext.Provider value={resolved}>
      <Outlet />
    </LocaleContext.Provider>
  );
}

export function useLocaleContext(): Locale {
  return useContext(LocaleContext);
}
